<template>
  <div class="tableContent" ref="tableContent" id="manageRole"> 
    <el-form  :model="searchForm" class="searchFrom" ref="searchForm">
      <el-form-item>
        <el-select v-model="searchForm.name.value" filterable clearable placeholder="角色名称" @focus="getRoleList">
          <el-option :value="item.name" v-for="item in roleList" :key="item.id" :label="item.name" > 
          </el-option> 
        </el-select>
      </el-form-item>
    </el-form>
    <div class="searchFormBtn">
      <div class="btnContainer" ref="btnContainer" v-if="$_has('/rampow_role/add')">
        <button class="btn btn-add"  @click="addRow">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_add"></use>
          </svg>新增
        </button>
        <button class="btn btn-del" @click="delBtnBatch" v-if="$_has('/rampow_role/del')" >
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_delete"></use>
          </svg>删除
        </button>
      </div>
      <div class="formBtnContainer">
        <span class="btn btn-add" @click="searchList">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_search"></use>
          </svg>
          <span>查询</span>
        </span>
        <span class="btn" @click="resetFrom">
          <svg class="icon" aria-hidden="true" >
            <use xlink:href="#icon_rest"></use>
          </svg>
          <span>重置</span>
        </span>
      </div>
    </div>
    
    <div class="tableContainer" v-if="$_has('/rampow_role/list')">
      <el-table :data="tableList"  v-loading="loading" ref="tableList" default-expand-all :height="tableHeight" border row-key="id"  @row-click="rowClick" :tree-props="{children: 'childlist', hasChildren: true}" style="width: 100%" header-row-class-name="tableHeader"   :row-class-name="tableRow"  @selection-change="handleSelectionChange">
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column prop="name" label="角色名称" class-name='alignLeft'>
           <template slot-scope="scope">
             <p v-html="scope.row.pre_name"></p>
          </template>
        </el-table-column>
        <el-table-column prop="remark"  label="描述" class-name='alignLeft'></el-table-column>        
        <el-table-column  label="操作" class-name='optionsCol'>
          <template slot-scope="scope" v-if="scope.row.id!=1">
            <span @click.stop="editRow(scope)" class="textBtnEdit" v-if="$_has('/rampow_role/edit')">编辑</span>
            <span @click.stop="delBtnClick(scope)" class="textBtnDel" v-if="$_has('/rampow_role/del')">删除</span>
          </template>
        </el-table-column>
        <div slot="empty">
					<p>
						<img src="@/assets/img/noData.png"/>
					</p>
					<p style="color:#030303;"><span>暂无相关数据</span></p>
				</div>
      </el-table>
    </div>
    <RoleOptions ref="roleOpts" v-show="showRoleOpts" :showRoleOpts="showRoleOpts" v-on:searchList="searchList" v-on:cancle='isShowRoleOpts()'></RoleOptions>
    <MessageBox ref="delRow" v-show="showDelMsgBox" v-on:success='delRow()' v-on:cancle='cancleDelRow()'></MessageBox>

  </div>
</template>

<script>
import { list, tree, del } from '@/api/wmsRole' 
import { setSearchParams } from '@/utils/index'
import RoleOptions from './WMSRoleOptions' 
import MessageBox from '@/components/MessageBox'

export default {
  data(){
    return{
      searchForm:{
        name:{value:'',op:'='}
      },
      tableHeight: null,
      tableList:[],
      delList:[],
      selectList:[],
      showRoleOpts:false,
      roleList:[],
      menuList:[],
      showDelMsgBox:false,
      loading:false
    }
  },
  components:{
    RoleOptions,    MessageBox
  },
  created(){
    this.searchList()
  },
  mounted(){
    let that = this;
    
    // 注：window.onresize只能在项目内触发1次
    window.onresize = function windowResize () {
        // 通过捕获系统的onresize事件触发我们需要执行的事件
      that.setTableHeight()
    }
    
  },


  methods:{
    resetFrom(){
       let menuManage = this.searchForm
      for(let item in menuManage){
        menuManage[item].value =''
      }
      this.searchList();
    },
    delRow(){
      if(this.delList && this.delList.length>0){
        let params = {
          del_id :JSON.stringify(this.delList) 
        }
        del(params).then(res=>{
          if(res.length==0){
            this.$message({message:'删除成功',type:'success'})
            this.searchList();
            this.cancleDelRow()      
          }else{

          }
        })
      }else {
        this.$message({message:'请选中删除的选项',type:'error'})
      }
    },
    delBtnClick(scope){
      let array = []
      array.push(scope.row.id)
      this.delList = array
      this.$refs.delRow.msg = {
        title:'确认删除',
        msg:'确认要删除此信息吗？',
        icon:'icon_delete_query'
      };
      this.isShowDelMsgBox()
    },
    cancleDelRow () {
      this.delList=[]
      this.isShowDelMsgBox()
    },
    isShowDelMsgBox(){
      this.showDelMsgBox = !this.showDelMsgBox
    },
    getRoleList(){
      tree().then(res=>{
        this.roleList = res.rows
      })
    },
    editRow(scope){
      this.$refs.roleOpts.isAdd = false
      this.$refs.roleOpts.id = scope.row.id
     
      this.isShowRoleOpts()
    },
    addRow(){
      this.$refs.roleOpts.isAdd = true
      this.$refs.roleOpts.id = ""
      this.isShowRoleOpts()
    },
    isShowRoleOpts(){
      this.showRoleOpts = !this.showRoleOpts
    },
    searchList(){
      this.loading = true
      let params =  setSearchParams(this.searchForm,this.page_size,this.current_page)
      list(params).then(res=>{
        let rows =this.appendStatus(res);
        this.tableList= rows
        this.loading = false
        this.setTableHeight()
      })
    },
    appendStatus(list){
      for(let item in list){
        if(list[item].status =="normal"){
          list[item].statusBoolean = true
        }else{
          list[item].statusBoolean = false
        }
        if(list[item].childlist && list[item].childlist.length>0){
          this.appendStatus(list[item].childlist)
        }
      }
      return list
    },
    rowClick(row, column, event){
      this.$refs.tableList.toggleRowSelection(row);
    },
    handleSelectionChange(list){
      let arr = new Array()
      for(let i in this.selectList){
        this.selectList[i].statusSelection = false
      }
      for (let item in list){
        arr.push(list[item].id)
        list[item].statusSelection = true
      }
      this.selectList = list
      this.delList = arr
    },
    tableRow({row}){
      let className = 'tableRow';
      if(row.statusSelection){
        className += ' statusSelect'
      }
      return className
    },
    setTableHeight(){
      this.tableHeight = "0"
      let searchFormHeight = this.$refs.searchForm.$el.offsetHeight + 34;
      let manageMenuHeight = this.$refs.tableContent.offsetHeight;
      let btnContainerHeight = 0
       if(this.$refs.btnContainer){
        btnContainerHeight = this.$refs.btnContainer.offsetHeight 
      }
      this.tableHeight = manageMenuHeight  - searchFormHeight  -btnContainerHeight - 20  +'px'
    },
     // 批量删除
    delBtnBatch(){
     if(this.delList && this.delList.length>0){
        this.$refs.delRow.msg = {
          title:'确认删除',
          msg:'确认要删除此信息吗？',
          icon:'icon_delete_query'
        };
        this.isShowDelMsgBox()
      }else {
        this.$message({message:'请选中删除的选项',type:'error'})
      }
    },
    curPageChange(value){
      this.current_page = value;
      this.searchList()
    },
    sizeChange(value){
      this.page_size = value;
      this.searchList()
    }
  }

}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
#manageRole{
  &.tableContent{
    position: initial;
  }
  .textBtnEdit{
    border-right: 1px solid #E9EDF0;

  }
  .el-form-item,.el-form-item__content,.el-input__inner{
    height: 36px;
    line-height: 36px;
  }
}

</style>